import axios from '../../axios';

// The feedback payload shape is declared server-side in the API
// (TTT.API/Controllers/Core/Feedback/FeedbackController.cs).

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    // example: data = {id : 8848829374612, guid : 177589d3-e5e5-4d2a-8d88-afbc44b7f50e}
    getFeedbackInfo({}, data) {
      return new Promise((resolve, reject) => {
        if (data.feedbackId) {
          axios.get(`core/feedback/feedbackid/${data.feedbackId}/guid/${data.guid}`).then((res) => resolve(res)).catch((error) => reject(error));
        }
        else if (data.bookingId) {
          // old - todo remove in 2022 season.
          axios.get(`core/feedback/bookingid/${data.bookingId}/guid/${data.guid}`).then((res) => resolve(res)).catch((error) => reject(error));
        }
      });
    },

    // example: data = {}
    postFeedBack({ }, feedback) {
      return new Promise((resolve, reject) => {
        axios.post('core/feedback', feedback).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },

  },
};
